import { ExtJsFilter } from '../../../../../../grid/utils/filters/types';

export enum ChildGroupColumn {
  NAME = 0,
  POLICY = 1,
}

export enum ChildGroupColumnKeys {
  NAME = 'name',
  POLICY = 'policy',
  POLICY_ID = 'activePolicy.policyId',
}

export interface ProtectedEntitiesViewTypes {
  // @ts-ignore
  [Constants.ProtectedEntities.EPS.viewType.EPS_TREE_VIEW]: Array<string>;
  // @ts-ignore
  [Constants.Companies.viewType.COMPANIES_VIEW]: Array<string>;
}

export interface ChildGroupReadRecordsParams {
  page: number;
  limit: number;
  additionalFilters: any;
  filter?: Array<ExtJsFilter<ChildGroupColumnKeys>>;
  protectedEntitiesViewTypes: ProtectedEntitiesViewTypes;
  dir?: string;
  sort?: string;
}
